<template>
    <div id="BaseView">
        <div class="row">
          <div class="col-12">
             <MdTitleRegInfo
              v-bind:RegistrationInfo="PatientTitle"
              v-bind:titlePrefix="MdTitle"
              v-bind:IsClinical="false"
              v-bind:patientCode="PatientCode">
            </MdTitleRegInfo>
          </div>
        </div>

        <slot name="content"></slot>
    </div>
</template>

<script>
import EnumService from '@/services/enum.service'
import ShowMessage from '@/components/messages/ShowMessage.js'
import DBFunctions from '@/common/DBFunctions.js'
import Utils from '@/common/utils'

export default {
  name: 'BaseView',
  props:{
    MdTitle:String,
    PatientCode:String
  },
  mixins: [ShowMessage, DBFunctions],
  components:{},
  data(){
    return {
    PatientTitle:{
       programName:'',
       fullName:'',
       admitDate:'',
       dischargeDate:'',
       dob:'',
       activitytypename:'',
       startdatetime:'',
       ageFormatted:''
     },
     OptionsRightMenu:{
        visible:true,
        ItemsList:[],
        btnvisible:true,
        itemdisabled: false,
        },
    }
  },

  computed:{

  },

  methods:{
    async GetPatientByCode(){
      var infoList = await this.getInfoTitle(this.PatientCode);
      if(infoList.length > 0){
          this.PatientTitle.programName = '';
          this.PatientTitle.admitDate = '';
          this.PatientTitle.dischargeDate = '';
          const { dob, firstname, lastname, age, ageFormatted } = infoList[0];
          if (ageFormatted) this.PatientTitle.ageFormatted = ageFormatted;
          if (dob) this.PatientTitle.dob = Utils.formatterDateToString(dob);
          if (age) this.PatientTitle.age = age;
          if (firstname) this.PatientTitle.fullName = firstname + ' '+ lastname;
      }
    },
  },

  created(){

  },

  mounted(){
    this.OptionsRightMenu.visible = true;
    this.OptionsRightMenu.ItemsList = EnumService.PatientItems;
    this.$emit("getVisibleMenu", this.OptionsRightMenu);
    this.GetPatientByCode();
  }

};
</script>


